import { render, staticRenderFns } from "./transactions-icon.vue?vue&type=template&id=2ca21157"
import script from "./transactions-icon.vue?vue&type=script&lang=js"
export * from "./transactions-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports